import { instance, getApiDomain } from '@cognitivecredit/ui-utils'
import { useChatAppStore } from '@/piniaStores/chatAppStore.ts'
import { storeToRefs } from 'pinia'

export const fetchChatThread = async (to) => {
  const chatAppStore = useChatAppStore()
  const { threads } = storeToRefs(chatAppStore)
  const { setCurrentThread, fetchThreadsHistory } = chatAppStore

  try {
    const req = await instance({ apiDomain: getApiDomain('chat-ai') })

    let threadsHistory = threads.value

    if (!threadsHistory.length) {
      threadsHistory = await fetchThreadsHistory()
    }

    const res = await req.get(`/ai/threads/${to.query.id}`)

    const thread = threadsHistory.find((t) => t.id === to.query.id)
    if (thread) {
      const messages = res.data.map((msg) => ({
        id: crypto.randomUUID(),
        isCollapsed: false,
        ...msg,
      }))
      setCurrentThread({ ...thread, messages })
      return true
    } else {
      return false
    }
  } catch (error) {
    console.error('Error fetching thread:', error)
    return false
  }
}

export const chatInProgress = (): boolean => {
  const chatAppStore = useChatAppStore()
  const { inProgressIds } = storeToRefs(chatAppStore)
  return !!inProgressIds.value.messageId
}

export const setDiscardWarning = (to) => {
  const chatAppStore = useChatAppStore()
  const { setShowDiscard } = chatAppStore
  setShowDiscard({ show: true, redirectTo: to.fullPath })
}

export const clearDiscardAndCurrentThread = () => {
  const chatAppStore = useChatAppStore()
  const { setShowDiscard, resetCurrentThreadState } = chatAppStore
  resetCurrentThreadState()
  setShowDiscard(undefined)
}
